import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

import styled from "styled-components";
import { cleanImageURL } from "@literati/public-ui-shared-react";

const StyledHeadingBanner = styled.section`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props["$backgroundColor"]};
  height: 320px;

  &::before {
    content: "";
    display: block;
    position: absolute;
    height: 100%;
    width: 100%;
    max-width: ${(props) => props["$maxImageWidth"] || "none"};
    left: 50%;
    transform: translateX(-50%);
    background-image: url(${(props) =>
      cleanImageURL(props["$backgroundImage"])});
    background-size: ${(props) =>
      props["$fullWidth"] ? "cover" : "auto 100%"};
    background-position: center ${(props) => props["$backgroundAlignment"]};
    background-repeat: no-repeat;
    top: 0;
    z-index: 0;
  }

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${(props) => props["$backgroundOverlayColor"] || "#000"};
    opacity: calc(${(props) => props["$backgroundOverlayOpacity"] || 0} / 100);
  }

  .heading {
    position: relative;
    text-align: center;
    font-size: 1.5rem;
    color: ${(props) => props["$headingTextColor"] || "#FFF"};
    z-index: 1;
    max-width: 600px;
    line-height: 2.25rem;

    ${({ theme }) => theme.media["md"]} {
      font-size: 2rem;
    }
  }
`;

const HeadingBanner = ({ entry }) => {
  const {
    headingDesktop,
    headingMobile,
    headingTextColor = "#000",
    backgroundImage,
    backgroundColor = "#000",
    backgroundOverlayColor = "transparent",
    backgroundOverlayOpacity = "0",
    backgroundAlignment = "center",
    maxImageWidth = 1600,
  } = entry;

  const fullWidth = backgroundAlignment === "full";

  return (
    <StyledHeadingBanner
      className={"heading-banner"}
      $backgroundImage={backgroundImage.file.url + "?h=320&q=75"}
      $headingTextColor={headingTextColor}
      $backgroundColor={backgroundColor}
      $backgroundOverlayColor={backgroundOverlayColor}
      $backgroundOverlayOpacity={backgroundOverlayOpacity}
      $maxImageWidth={maxImageWidth}
      $fullWidth={fullWidth}
    >
      <div className={"overlay"} />
      <div className={"heading md:hidden"}>
        {documentToReactComponents(headingMobile)}
      </div>
      <div className={"heading px-6 font-serif hidden md:block"}>
        {documentToReactComponents(headingDesktop)}
      </div>
    </StyledHeadingBanner>
  );
};

export default HeadingBanner;
